<div *ngIf="this.cargado">
      <iframe [src]="url" title="modulo-bi" style="position: absolute; height: 100%; width: 100%; border: none">
    </iframe>
</div>
